<template>
  <div id="game-wrapper">
    <div id="title-screen" :class="{'active':showTitleScreen}"  @click="startGame" @touchstart="startGame"></div>
    <div id="game" :class="{'active':showGame}">
      <img src="../src/assets/img/game_BG.jpg">
    </div>
    <div v-for="item in foundItems" :key="item.id" :id="'small-'+item.name" :class="{'active': item.active}">
      <img :src="require('@/assets/img/'+ item.name + '.png')" alt="item.name">
    </div>
    <div id="draggables" :class="{'active': showGame}">
      <div
        v-for='item in draggableItems'
        :key='item.id'
        :id="'big-'+item.name"
        :class="{ 'active': item.active, draggable: true, dragged: item.dragged, placed: item.placed}"
        @touchstart='startDrag($event, item)'
        @mousedown='startDrag($event, item)'
        @touchend='dragEnd($event, item)'
        @mouseup='dragEnd($event, item)'
      >
        <img :src="require('@/assets/img/big/'+ item.name + '.png')" alt="item.name">
      </div>
    </div>
    <div
      v-for="item in dropableItems"
      :key="item.id"
      :id="item.name"
      :class="{'dropable': true}"
      @drop='onDrop($event, 1)'
      @dragover.prevent
      @dragenter.prevent
    ></div>
    <div class="message active" v-if="message" v-on:click="closeMessage">
      <div :class="{'popup': true, 'wide': widerMessage}">
        <p v-html="messageContent"></p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'JuengstesGericht',
  data () {
    return {
      $dragElement: null,
      dragItem: null,
      lastDragItemName: null,
      showTitleScreen: true,
      showGame: false,
      message: false,
      messageContent: '',
      widerMessage: false,
      messages: [
        { id: 0, html: '<b>Was glaubst du?</b> <br>Wer gehört in die Hölle und wer in den Himmel? <br>Ziehe die Figuren an den richtigen Platz.' },
        { id: 1, html: '<b>Das war sehr gut!</b> Du hast alles richtig zugeordnet.' }
      ],
      draggableItems: [
        { id: 0, name: '01', html: '<b>Habgier wird bestraft!</b> Der Teufel steckt dem Spielsüchtigen die Karten in den Mund.', required: 'Hell', active: true },
        { id: 1, name: '02', html: '<b>Oh, der Papst!</b> Auch Geistliche können sündigen. Er hält sich vor Scham die Augen zu.', required: 'Hell', active: false },
        { id: 2, name: '03', html: '<b>Willkommen im Himmel!</b> Ein Seliger wird von Petrus begrüßt.', required: 'Heaven', active: false },
        { id: 3, name: '04', html: '<b>Oh wei!</b> Das passiert, wenn man zu gierig ist: Der Teufel zwingt den Sünder, Würmer zu essen.', required: 'Hell', active: false },
        { id: 4, name: '05', html: '<b>Freut euch!</b> Die Seligen im Himmel lächeln.', required: 'Heaven', active: false },
        { id: 5, name: '06', html: '<b>Eitelkeit</b> ist eine Sünde, deshalb hält der Teufel der Frau den Spiegel vor.', required: 'Hell', active: false }
      ],
      foundItems: [
        { id: 10, name: '01', active: false },
        { id: 11, name: '02', active: false },
        { id: 12, name: '03', active: false },
        { id: 13, name: '04', active: false },
        { id: 14, name: '05', active: false },
        { id: 15, name: '06', active: false }
      ],
      dropableItems: [
        { id: 8, name: 'Hell' },
        { id: 9, name: 'Heaven' }
      ],
      placedItems: [],
      touchmoveEventListener: (evt) => { this.drag(evt) },
      touchendEventListener: (evt) => { this.dragEnd(evt) }
    }
  },
  methods: {
    startGame () {
      this.showTitleScreen = false
      this.showGame = true
      setTimeout(this.showMessage, 10, this.messages[0].html)
    },
    startDrag (evt, item) {
      evt.preventDefault()
      evt.stopPropagation()
      if (!this.placedItems.includes(item.id)) {
        this.$dragElement = evt.target
        if (this.$dragElement.nodeName === 'IMG') this.$dragElement = this.$dragElement.parentNode
        const box = this.$dragElement.getBoundingClientRect()
        const c = evt.type.match(/^touch/) ? evt.touches[0] : evt
        this.$dragElement.mouseOffset = { x: c.clientX - box.left, y: c.clientY - box.top }
        this.$dragElement.style.left = (c.clientX - this.$dragElement.mouseOffset.x - this.$el.offsetLeft) + 'px'
        this.$dragElement.style.top = (c.clientY - this.$dragElement.mouseOffset.y - this.$el.offsetTop) + 'px'
        this.$set(item, 'dragged', true)
        this.dragItem = item
        window.addEventListener(evt.type === 'mousedown' ? 'mousemove' : 'touchmove', this.touchmoveEventListener)
        window.addEventListener(evt.type === 'mousedown' ? 'mouseup' : 'touchend', this.touchendEventListener)
      }
    },
    drag (evt) {
      evt.preventDefault()
      evt.stopPropagation()
      if (this.$dragElement && this.$dragElement.mouseOffset) {
        const c = evt.type.match(/^touch/) ? evt.touches[0] : evt
        this.$dragElement.style.left = (c.clientX - this.$dragElement.mouseOffset.x - this.$el.offsetLeft) + 'px'
        this.$dragElement.style.top = (c.clientY - this.$dragElement.mouseOffset.y - this.$el.offsetTop) + 'px'
      }
    },
    dragEnd (evt) {
      if (this.dragItem) {
        const c = evt.type.match(/^touch/) ? evt.changedTouches[0] : evt
        const box = this.dragItem.required ? this.$el.querySelector('#' + this.dragItem.required).getBoundingClientRect() : null
        if (box) {
          const clickMargin = box.width / 4
          if (box.left < c.clientX && box.right - clickMargin > c.clientX && box.top < c.clientY && box.bottom > c.clientY) {
            this.onDrop()
            return
          }
        }
        this.resetDragElement()
        this.removeEventListeners()
        this.$dragElement = null
        this.dragItem = null
      }
    },
    onDrop () {
      if (this.dragItem) {
        this.showMessage(this.dragItem.html)
        this.draggableItems[this.placedItems.length].active = false
        this.placedItems.push(this.dragItem.id)
        this.lastDragItemName = this.dragItem.name
        this.$dragElement = null
        this.dragItem = null
      }
    },
    resetDragElement () {
      if (this.$dragElement) {
        this.$dragElement.style.zIndex = 'auto'
        this.$dragElement.style.left = null
        this.$dragElement.style.top = null
        this.$set(this.dragItem, 'dragged', false)
      }
    },
    removeEventListeners () {
      window.removeEventListener('mousemove', this.touchmoveEventListener)
      window.removeEventListener('touchmove', this.touchmoveEventListener)
      window.removeEventListener('mouseup', this.touchendEventListener)
      window.removeEventListener('touchend', this.touchendEventListener)
    },
    closeMessage () {
      this.message = false
      this.messageContent = ''
      if (this.lastDragItemName != null) {
        for (var n = 0; n < this.foundItems.length; n++) {
          if (this.foundItems[n].name === this.lastDragItemName) this.foundItems[n].active = true
        }
        setTimeout(this.showNextItem, 1000)
        this.lastDragItemName = null
      }
      if (this.placedItems.length === this.draggableItems.length) {
        this.placedItems.push('ende')
        this.showMessage(this.messages[1].html)
      }
    },
    showMessage (htmlText) {
      this.message = true
      this.widerMessage = htmlText.length > 150
      this.messageContent = htmlText
    },
    showNextItem () {
      if (this.placedItems.length < this.draggableItems.length) this.draggableItems[this.placedItems.length].active = true
    }
  }
}
</script>
